import React from "react";

const QuestionRenderer = ({
    question,
    answer,
    onChange
}) => {

    if (!question) {
        return null;
    }


    // ? CONFIGURATION QUESTION

    const questionType = question?.type;
    const questionId = String(question?.id || "");

    const getOptionId = (
        option
    ) => {
        return String(option?.id || "");
    };

    const getOptionText = (
        option
    ) => {
        return (
            option?.text ||
            option?.label ||
            option?.value ||
            "Opción"
        );
    };

    const sortedOptions = Array.isArray(question?.options)
        ? [...question.options].sort(
            (a, b) =>
                Number(a?.sortOrder || 0) -
                Number(b?.sortOrder || 0)
        )
        : [];




    // * PREGUNTA ABIERTA
    if (questionType === "open") {
        return (
            <div className="survey-runner-open">

                <textarea
                    rows={4}
                    className="survey-runner-open-input"
                    placeholder={
                        question?.placeholder ||
                        "Escriba su respuesta..."
                    }
                    value={answer?.value || ""}
                    onChange={(event) => {
                        onChange({
                            id_question: questionId,
                            type: questionType,
                            value: event.target.value,
                            selectedOptions: [],
                            subAnswers: {}
                        });
                    }}
                />

            </div>
        );
    }

    //* PREGUNTA DE LA HORA
    if (questionType === "time") {

        const getCurrentTime = () => {

            const now = new Date();
            const hours = String(now.getHours()).padStart(2, "0");
            const minutes = String(now.getMinutes()).padStart(2, "0");

            return `${hours}:${minutes}`;
        };


        const calculateElapsedTime = (selectedTime) => {

            if (!selectedTime) {
                return null;
            }

            const [selectedHours, selectedMinutes] =
                selectedTime
                    .split(":")
                    .map(Number);


            const now = new Date();

            const selectedDate = new Date();

            selectedDate.setHours(
                selectedHours,
                selectedMinutes,
                0,
                0
            );


            if (selectedDate.getTime() > now.getTime()) {
                selectedDate.setDate(
                    selectedDate.getDate() - 1
                );
            }


            const differenceMilliseconds = now.getTime() - selectedDate.getTime();
            const totalMinutes = Math.floor(differenceMilliseconds / 60000);
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;


            let label = "";


            if (hours > 0) { label += `${hours} h`; }


            if (minutes > 0) {

                label += `${hours > 0 ? " " : ""}${minutes} min`;
            }


            if (hours === 0 && minutes === 0) {

                label = "0 min";
            }


            return {
                hours,
                minutes,
                totalMinutes,
                label
            };
        };


        const formatTimeToAMPM = (time) => {

            if (!time) {
                return "";
            }

            const [hourString, minutes] = time.split(":");

            const hourNumber = Number(hourString);

            const period = hourNumber >= 12 ? "PM" : "AM";

            const hour12 = hourNumber % 12 || 12;

            return `${hour12}:${minutes} ${period}`;
        };


        const currentTime = getCurrentTime();
        const selectedTime = answer?.rawTime || "";
        const elapsedTime = calculateElapsedTime(selectedTime);


        const handleTimeChange = (event) => {

            const newSelectedTime = event.target.value;


            if (!newSelectedTime) {

                onChange({
                    id_question: questionId,
                    type: questionType,
                    value: "",
                    rawTime: "",
                    selectedOptions: [],
                    subAnswers: {}
                });

                return;
            }


            const calculatedElapsedTime = calculateElapsedTime(newSelectedTime);
            const formattedTime = formatTimeToAMPM(newSelectedTime);
            const fastingLabel = calculatedElapsedTime?.label ?? "0 min";
            const valueToSave = `Hora: ${formattedTime} con un ayuno de ${fastingLabel}`;


            onChange({
                id_question: questionId,
                type: questionType,
                value: valueToSave,
                rawTime: newSelectedTime,
                selectedOptions: [],
                subAnswers: {}
            });
        };


        return (

            <div className="survey-runner-time">
                <div className="survey-runner-time-card">
                    <div className="survey-runner-time-icon">
                        <i className="fa fa-clock-o" />
                    </div>

                    <div className="survey-runner-time-content">
                        <label className="survey-runner-time-label">
                            Seleccione una hora
                        </label>
                        <div className="survey-runner-time-controls">
                            <input
                                type="time"
                                className="survey-runner-time-input"
                                value={selectedTime}
                                step="60"
                                onChange={
                                    handleTimeChange
                                }
                            />
                            <button
                                type="button"
                                className="survey-runner-time-result"
                                tabIndex={-1}
                            >

                                <i className="fa fa-clock-o" />
                                <span>
                                    ayuno{" "}
                                    <strong>
                                        {elapsedTime?.label ?? "---"}
                                    </strong>
                                </span>
                            </button>
                        </div>

                        <small className="survey-runner-time-help">
                            Si selecciona una hora posterior a la actual,
                            se tomará como correspondiente al día anterior.
                        </small>
                    </div>
                </div>
            </div>
        );
    }

    // * OPCION MULTIPLE
    if (questionType === "multiple") {

        const allowMultiple =
            Boolean(question?.allowMultiple);

        const displayType =
            question?.displayType || "button";

        const selectedOptions =
            Array.isArray(answer?.selectedOptions)
                ? answer.selectedOptions.map(String)
                : [];

        const handleSelectOption = (option) => {

            const optionId = getOptionId(option);

            let newSelectedOptions = [];

            if (allowMultiple) {

                const optionIsSelected =
                    selectedOptions.includes(optionId);

                newSelectedOptions = optionIsSelected
                    ? selectedOptions.filter(
                        selectedId =>
                            selectedId !== optionId
                    )
                    : [
                        ...selectedOptions,
                        optionId
                    ];

            } else {

                newSelectedOptions = [optionId];
            }

            const previousSubAnswers =
                answer?.subAnswers || {};

            const newSubAnswers = {};

            newSelectedOptions.forEach(selectedId => {

                if (previousSubAnswers[selectedId]) {
                    newSubAnswers[selectedId] =
                        previousSubAnswers[selectedId];
                }
            });

            onChange({
                id_question: questionId,
                type: questionType,
                value: null,
                selectedOptions: newSelectedOptions,
                subAnswers: newSubAnswers
            });
        };

        const renderSelector = (isSelected) => {

            if (displayType === "checkbox") {
                return (
                    <span
                        className={`survey-runner-control survey-runner-control-checkbox ${isSelected
                            ? "survey-runner-control-selected"
                            : ""
                            }`}
                    >
                        {isSelected && (
                            <i className="fa fa-check" />
                        )}
                    </span>
                );
            }

            if (displayType === "radio") {
                return (
                    <span
                        className={`survey-runner-control survey-runner-control-radio ${isSelected
                            ? "survey-runner-control-selected"
                            : ""
                            }`}
                    >
                        {isSelected && (
                            <span className="survey-runner-radio-dot" />
                        )}
                    </span>
                );
            }

            return null;
        };

        return (
            <div
                className={`survey-runner-options survey-runner-options-${displayType}`}
            >
                <div className="survey-runner-options-panel">
                    <div
                        className={`survey-runner-options-grid survey-runner-options-grid-${displayType}`}
                    >
                        {sortedOptions.map((option) => {

                            const optionId =
                                getOptionId(option);

                            const isSelected =
                                selectedOptions.includes(optionId);

                            return (
                                <button
                                    key={optionId}
                                    type="button"
                                    className={`survey-runner-option survey-runner-option-${displayType} ${isSelected
                                        ? "survey-runner-option-selected"
                                        : ""}
                                `}
                                    onClick={() =>
                                        handleSelectOption(option)
                                    }
                                >
                                    {renderSelector(isSelected)}

                                    <span className="survey-runner-option-text">
                                        {getOptionText(option)}
                                    </span>
                                </button>
                            );
                        })}
                    </div>

                </div>

                {sortedOptions.map((option) => {

                    const optionId =
                        getOptionId(option);

                    const isSelected =
                        selectedOptions.includes(optionId);

                    const hasSubQuestion =
                        Boolean(option?.hasSubQuestion);

                    if (
                        !isSelected ||
                        !hasSubQuestion ||
                        !option?.subQuestion
                    ) {
                        return null;
                    }

                    return (
                        <div
                            key={`sub-${optionId}`}
                            className="survey-runner-subquestion"
                        >
                            <div className="survey-runner-subquestion-label">
                                Pregunta relacionada
                            </div>

                            <div className="survey-runner-subquestion-title">
                                {option.subQuestion.question}

                                {option.subQuestion.required && (
                                    <span className="survey-runner-required">
                                        *
                                    </span>
                                )}
                            </div>

                            <QuestionRenderer
                                question={option.subQuestion}
                                answer={
                                    answer?.subAnswers?.[optionId]
                                }
                                onChange={(subAnswer) => {

                                    onChange({
                                        id_question: questionId,
                                        type: questionType,
                                        value: null,
                                        selectedOptions,
                                        subAnswers: {
                                            ...answer?.subAnswers,
                                            [optionId]: subAnswer
                                        }
                                    });
                                }}
                            />
                        </div>
                    );
                })}

            </div>
        );
    }

    // * QUIESTION COMPLEX
    if (questionType === "complex") {

        const selectedOptionId = String(
            answer?.selectedOptions?.[0] || ""
        );

        const selectedOption = sortedOptions.find(
            option =>
                getOptionId(option) === selectedOptionId
        );

        const handleSelectComplexOption = (option) => {

            const optionId = getOptionId(option);

            const previousSubAnswer =
                answer?.subAnswers?.[optionId];

            onChange({
                id_question: questionId,
                type: questionType,
                value: null,
                selectedOptions: [optionId],
                subAnswers: previousSubAnswer
                    ? {
                        [optionId]: previousSubAnswer
                    }
                    : {}
            });
        };

        return (
            <div className="survey-runner-complex">

                <div className="survey-runner-complex-options-grid">

                    {sortedOptions.map((option) => {

                        const optionId = getOptionId(option);

                        const isSelected =
                            selectedOptionId === optionId;

                        return (
                            <button
                                key={optionId}
                                type="button"
                                className={`
                                survey-runner-complex-option
                                ${isSelected
                                        ? "survey-runner-complex-option-selected"
                                        : ""
                                    }
                            `}
                                onClick={() =>
                                    handleSelectComplexOption(option)
                                }
                            >
                                <span className="survey-runner-complex-option-text">
                                    {getOptionText(option)}
                                </span>

                                {isSelected && (
                                    <span className="survey-runner-complex-option-check">
                                        <i className="fa fa-check" />
                                    </span>
                                )}
                            </button>
                        );
                    })}

                </div>

                {selectedOption?.hasSubQuestion &&
                    selectedOption?.subQuestion && (

                        <div className="survey-runner-complex-subquestion">

                            <div className="survey-runner-complex-subquestion-header">

                                <div className="survey-runner-complex-subquestion-icon">
                                    <i className="fa fa-list-ul" />
                                </div>

                                <div>
                                    {/* <div className="survey-runner-complex-subquestion-label">
                                        Información relacionada
                                    </div> */}

                                    <div className="survey-runner-complex-subquestion-title">
                                        {selectedOption.subQuestion.question}

                                        {selectedOption.subQuestion.required && (
                                            <span className="survey-runner-required">
                                                *
                                            </span>
                                        )}
                                    </div>
                                </div>

                            </div>

                            <div className="survey-runner-complex-subquestion-content">
                                <QuestionRenderer
                                    question={selectedOption.subQuestion}
                                    answer={
                                        answer?.subAnswers?.[
                                        selectedOptionId
                                        ]
                                    }
                                    onChange={(subAnswer) => {

                                        onChange({
                                            id_question: questionId,
                                            type: questionType,
                                            value: null,
                                            selectedOptions: [
                                                selectedOptionId
                                            ],
                                            subAnswers: {
                                                [selectedOptionId]:
                                                    subAnswer
                                            }
                                        });
                                    }}
                                />
                            </div>

                        </div>
                    )}

            </div>
        );
    }

    // * QUESTION CLOSED
    if (questionType === "closed") {

        const selectedOptionId =
            String(
                answer?.selectedOptions?.[0] || ""
            );

        const handleSelectClosedOption = (option) => {

            const optionId =
                getOptionId(option);

            onChange({
                id_question: questionId,
                type: questionType,
                value:
                    option?.value ||
                    option?.label ||
                    option?.text ||
                    "",
                selectedOptions: [optionId],
                subAnswers:
                    answer?.subAnswers?.[optionId]
                        ? {
                            [optionId]:
                                answer.subAnswers[optionId]
                        }
                        : {}
            });
        };

        const selectedOption =
            sortedOptions.find(
                option =>
                    getOptionId(option) ===
                    selectedOptionId
            );



        // * ----
        // const renderOptions = () => {
        //     const options = question?.options || [];

        //     const isMultipleSelection =
        //         question?.type === "multiple" &&
        //         Boolean(question?.allowMultiple);

        //     const displayType =
        //         question?.type === "multiple"
        //             ? question?.displayType || "button"
        //             : "button";

        //     const isSelected = (option) => {
        //         const optionValue = option?.id || option?.value;

        //         if (isMultipleSelection) {
        //             return Array.isArray(answer) &&
        //                 answer.includes(optionValue);
        //         }

        //         return answer === optionValue;
        //     };

        //     const handleSelectOption = (option) => {
        //         const optionValue = option?.id || option?.value;

        //         if (isMultipleSelection) {
        //             const currentAnswers = Array.isArray(answer)
        //                 ? answer
        //                 : [];

        //             const alreadySelected =
        //                 currentAnswers.includes(optionValue);

        //             const newAnswer = alreadySelected
        //                 ? currentAnswers.filter(
        //                     (value) => value !== optionValue
        //                 )
        //                 : [...currentAnswers, optionValue];

        //             onChange(newAnswer);
        //             return;
        //         }

        //         onChange(optionValue);
        //     };

        //     return (
        //         <div
        //             className={`
        //         survey-runner-options-panel
        //         ${displayType === "checkbox"
        //                     ? "survey-runner-options-panel-checkbox"
        //                     : ""
        //                 }
        //     `}
        //         >
        //             <div
        //                 className={`
        //             survey-runner-options-grid
        //             ${displayType === "checkbox"
        //                         ? "survey-runner-options-grid-checkbox"
        //                         : ""
        //                     }
        //         `}
        //             >
        //                 {options.map((option) => {
        //                     const selected = isSelected(option);

        //                     return (
        //                         <button
        //                             key={option?.id}
        //                             type="button"
        //                             className={`
        //                         survey-runner-option-button
        //                         ${selected
        //                                     ? "survey-runner-option-button-selected"
        //                                     : ""
        //                                 }
        //                     `}
        //                             onClick={() =>
        //                                 handleSelectOption(option)
        //                             }
        //                         >
        //                             <span
        //                                 className={`
        //                             survey-runner-option-selector
        //                             ${isMultipleSelection
        //                                         ? "survey-runner-option-selector-checkbox"
        //                                         : "survey-runner-option-selector-radio"
        //                                     }
        //                             ${selected
        //                                         ? "survey-runner-option-selector-selected"
        //                                         : ""
        //                                     }
        //                         `}
        //                             >
        //                                 {isMultipleSelection ? (
        //                                     <i
        //                                         className={
        //                                             selected
        //                                                 ? "fa fa-check-square"
        //                                                 : "fa fa-square-o"
        //                                         }
        //                                     />
        //                                 ) : (
        //                                     <i
        //                                         className={
        //                                             selected
        //                                                 ? "fa fa-dot-circle-o"
        //                                                 : "fa fa-circle-o"
        //                                         }
        //                                     />
        //                                 )}
        //                             </span>

        //                             <span className="survey-runner-option-text">
        //                                 {option?.text ||
        //                                     option?.label ||
        //                                     "Sin texto"}
        //                             </span>
        //                         </button>
        //                     );
        //                 })}
        //             </div>
        //         </div>
        //     );
        // };










        return (
            <div className="survey-runner-closed">

                <div className="survey-runner-options-grid">

                    {sortedOptions.map((option) => {

                        const optionId =
                            getOptionId(option);

                        const isSelected =
                            selectedOptionId === optionId;

                        return (
                            <button
                                key={optionId}
                                type="button"
                                // className={`
                                //     survey-runner-option-button
                                //     ${isSelected
                                //         ? "survey-runner-option-button-selected"
                                //         : ""
                                //     }
                                // `}
                                className={`
    survey-runner-option-button
    ${isSelected
                                        ? "survey-runner-option-selected"
                                        : ""
                                    }
`}
                                onClick={() =>
                                    handleSelectClosedOption(
                                        option
                                    )
                                }
                            >
                                <span className="survey-runner-option-selector">
                                    <i
                                        className={
                                            isSelected
                                                ? "fa fa-dot-circle-o"
                                                : "fa fa-circle-o"
                                        }
                                    ></i>
                                </span>

                                <span>
                                    {getOptionText(option)}
                                </span>
                            </button>
                        );
                    })}

                </div>

                {selectedOption?.hasSubQuestion &&
                    selectedOption?.subQuestion && (

                        <div className="survey-runner-subquestion">

                            <div className="survey-runner-subquestion-title">
                                {
                                    selectedOption
                                        .subQuestion
                                        .question
                                }
                            </div>

                            <QuestionRenderer
                                question={
                                    selectedOption.subQuestion
                                }
                                answer={
                                    answer?.subAnswers?.[
                                    selectedOptionId
                                    ]
                                }
                                onChange={(subAnswer) => {

                                    onChange({
                                        ...answer,

                                        subAnswers: {
                                            ...answer?.subAnswers,

                                            [selectedOptionId]:
                                                subAnswer
                                        }
                                    });
                                }}
                            />

                        </div>
                    )}

            </div>
        );
    }





    return (
        <div className="survey-runner-unsupported">
            El tipo de pregunta&nbsp;
            <strong>{questionType}</strong>
            &nbsp;no está disponible.



        </div>

    );

};


export default QuestionRenderer;